export default "__VITE_ASSET__4b84da0c__"